import { useQuery } from '@tanstack/react-query';
import type { MemoriesResponse } from './types';

export default function useMemories(queryKey: string[]) {
  return useQuery<MemoriesResponse>({ queryKey });
}
